import { render, staticRenderFns } from "./DiscountsClosed.vue?vue&type=template&id=595ec917&lang=pug"
import script from "./DiscountsClosed.vue?vue&type=script&lang=js"
export * from "./DiscountsClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports